<template>
  <div class="relative">
    <!-- 햄버거 메뉴 버튼 -->
    <button
      @click="isOpen = !isOpen"
      class="p-0 hover:bg-gray-100 rounded-lg flex items-center"
      title="메뉴"
    >
      <span class="material-icons">menu</span>
    </button>

    <!-- 드롭다운 메뉴 -->
    <div
      v-if="isOpen"
      class="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50"
    >
      <button
        class="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
        @click="handleMainChatClick"
        title="메인 채팅"
      >
        Main Chat
      </button>
      <router-link
        to="/model-playground"
        class="block px-4 py-2 text-gray-700 hover:bg-gray-100"
        title="모델 플레이그라운드"
      >
        Model Playground
      </router-link>
      <router-link
        to="/role-playground"
        class="block px-4 py-2 text-gray-700 hover:bg-gray-100"
        title="역할 플레이그라운드"
      >
        Role Playground
      </router-link>
      <router-link
        to="/secure-playground"
        class="block px-4 py-2 text-gray-700 hover:bg-gray-100"
        title="보안 플레이그라운드"
      >
        Secure Playground
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'AppHamburgerMenu',
  data() {
    return {
      isOpen: false
    }
  },
  props: {
    debugMode: {
      type: Boolean,
      required: true
    }
  },
  emits: ['new-chat'],
  methods: {
    ...mapActions(['setSidebarVisible']),
    toggleDebugMode() {
      this.$emit('toggle-debug')
      this.isOpen = false
    },
    closeMenu(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
      }
    },
    handleMainChatClick() {
      if (this.$route.path !== '/chat') {
        this.$router.push('/chat');
      }
      this.$emit('new-chat');
      this.isOpen = false;
    },
  },
  mounted() {
    document.addEventListener('click', this.closeMenu)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeMenu)
  }
}
</script>

<style scoped>
button:focus,
button:focus-visible {
  outline: none !important;
}

button:focus span,
button:focus-visible span {
  outline: 1px solid rgba(0,123,255,.836); /* 링 두께 1px */
  outline-offset: 5px;                     /* 버튼/아이콘과 띄우는 거리 */
  border-radius: 50%;
  padding: 0px;  
}
</style>